import * as React from 'react';
import styled, { css } from 'styled-components';
import { grid } from '@lendi-ui/grid';
import { gte } from '@lendi-ui/breakpoint';
import { normalise } from '@lendi-ui/utils';
import getColour from '@lendi-ui/commons/colours';
import { body } from '@lendi-ui/typography';
import { getThemeName } from '@lendi-ui/commons/utils';
import { jsx, jsxs } from 'react/jsx-runtime';
import ChevronLeft from '@lendi-ui/icon/ChevronLeft';
import ChevronRight from '@lendi-ui/icon/ChevronRight';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject, _templateObject2;
var GRADIENT = 0;
var ICON = 1;
var commonScrollGradientStyle = css(["position:sticky;content:'\\2007 \\2007';width:20px;pointer-events:none;z-index:", ";"], GRADIENT);
var commonIconWrapperStyle = css(["display:flex;flex-direction:column;justify-content:center;position:sticky;cursor:pointer;z-index:", ";"], ICON);
var Wrapper = styled.div.withConfig({
  displayName: "indexstyle__Wrapper",
  componentId: "lui__sc-1sgql9s-0"
})(["", ";", ";", ";min-height:30px;overflow-x:auto;width:100%;position:relative;", ";"], normalise, grid({
  halign: 'left',
  wrap: false,
  gutter: 'nil'
}), props => props.isInverse ? 'background: transparent' : "background-color: ".concat(getColour('buttonFill', 'primary')), props => props.isScrollable && "&::after {\n    ".concat(commonScrollGradientStyle, "\n    right: 0px;\n    background: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.15));\n    }\n    &::before {\n      ").concat(commonScrollGradientStyle, "\n      left: 0px;\n      background: linear-gradient(to left, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.15));\n    }\n  "));
var RightIconWrapper = styled.div.withConfig({
  displayName: "indexstyle__RightIconWrapper",
  componentId: "lui__sc-1sgql9s-1"
})(["display:none;", ";"], gte('desktop')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n    right: 0px;\n    margin-right: -20px;\n  "])), commonIconWrapperStyle));
var LeftIconWrapper = styled.div.withConfig({
  displayName: "indexstyle__LeftIconWrapper",
  componentId: "lui__sc-1sgql9s-2"
})(["display:none;", ";"], gte('desktop')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", "\n    left: 0px;\n    margin-left: -20px;\n  "])), commonIconWrapperStyle));
var commonActiveBarStyle = css(["bottom:0;content:'';height:2px;position:absolute;width:inherit;"]);
var ActiveBar = styled.span.withConfig({
  displayName: "indexstyle__ActiveBar",
  componentId: "lui__sc-1sgql9s-3"
})(["", ""], _ref => {
  var {
    styles
  } = _ref;
  return css(["background-color:", ";", " ", ""], getColour('shade', 100), commonActiveBarStyle, _objectSpread2({}, styles));
});

var TabWrapper = css(["border:0;background:none;color:", ";cursor:pointer;position:relative;", ";&:focus-visible{outline:none;background-color:rgba(0,0,0,0.1);}&:active{background-color:rgba(0,0,0,0.2);}&:hover{background-color:rgba(0,0,0,0.1);}"], () => getThemeName() === 'lendi' ? '#0d5a6d' : getColour('interaction', 'main'), body({
  size: 'sm'
}));
var TabWrapperBtn = styled.button.withConfig({
  displayName: "indexstyle__TabWrapperBtn",
  componentId: "lui__sc-1yphgki-0"
})(["", ";"], TabWrapper);
var TabWrapperA = styled.a.withConfig({
  displayName: "indexstyle__TabWrapperA",
  componentId: "lui__sc-1yphgki-1"
})(["", ";text-decoration:none;display:flex;flex-direction:column;align-items:center;justify-content:center;"], TabWrapper);
var TabActiveBar = styled.span.withConfig({
  displayName: "indexstyle__TabActiveBar",
  componentId: "lui__sc-1yphgki-2"
})(["", " ", ""], _ref => {
  var {
    isSelected
  } = _ref;
  return isSelected && (getThemeName() === 'lendi' ? 'background-color: #6d9ca7;' : "background-color: ".concat(getColour('interaction', 'contrast'), ";"));
}, _ref2 => {
  var {
    styles
  } = _ref2;
  return css(["", " left:0px;right:0px;", ""], commonActiveBarStyle, _objectSpread2({}, styles));
});

var TabContext = /*#__PURE__*/React.createContext({
  onClick: () => true,
  selectedIndex: 0
});

var _excluded$1 = ["icon", "index", "children", "href"];
var Tab = _ref => {
  var {
    icon,
    index = 0,
    children: _children,
    href
  } = _ref,
      otherTabProps = _objectWithoutProperties(_ref, _excluded$1);

  return /*#__PURE__*/jsx(TabContext.Consumer, {
    children: state => {
      var isSelected = state.selectedIndex === index;
      var _onClick = state.onClick;
      var styles = state.styles;

      if (href) {
        return /*#__PURE__*/jsxs(TabWrapperA, _objectSpread2(_objectSpread2({
          onClick: () => _onClick(index),
          href: href
        }, otherTabProps), {}, {
          role: "tab",
          "aria-selected": isSelected,
          children: [icon && /*#__PURE__*/jsx(React.Fragment, {
            children: icon
          }), /*#__PURE__*/jsx(React.Fragment, {
            children: _children
          }), /*#__PURE__*/jsx(TabActiveBar, {
            isSelected: isSelected,
            styles: styles
          })]
        }));
      } else {
        return /*#__PURE__*/jsxs(TabWrapperBtn, _objectSpread2(_objectSpread2({
          onClick: () => _onClick(index)
        }, otherTabProps), {}, {
          role: "tab",
          "aria-selected": isSelected,
          children: [icon && /*#__PURE__*/jsx(React.Fragment, {
            children: icon
          }), /*#__PURE__*/jsx(React.Fragment, {
            children: _children
          }), /*#__PURE__*/jsx(TabActiveBar, {
            isSelected: isSelected,
            styles: styles
          })]
        }));
      }
    }
  });
};

var _excluded = ["children", "isInverse", "activeTabIndex", "onChangeTabIndex", "activeBarStyles"];
class Tabs extends React.Component {
  constructor() {
    super(...arguments);

    _defineProperty(this, "node", /*#__PURE__*/React.createRef());

    _defineProperty(this, "state", {
      isScrollable: false
    });

    _defineProperty(this, "handleMoveScrollbarLeft", () => {
      if (this.node.current) {
        this.node.current.scrollBy({
          top: 0,
          left: 120,
          behavior: 'smooth'
        });
      }
    });

    _defineProperty(this, "handleMoveScrollbarRight", () => {
      if (this.node.current) {
        this.node.current.scrollBy({
          top: 0,
          left: -120,
          behavior: 'smooth'
        });
      }
    });

    _defineProperty(this, "renderTab", (child, index) => {
      if ( /*#__PURE__*/React.isValidElement(child)) {
        return /*#__PURE__*/React.cloneElement(child, {
          index
        });
      }

      return child;
    });

    _defineProperty(this, "handleClick", index => {
      this.props.onChangeTabIndex(index);
    });

    _defineProperty(this, "calculateTabWidth", () => {
      if (this.node.current) {
        this.setState({
          isScrollable: this.node.current.scrollWidth > this.node.current.clientWidth
        });
      }
    });
  }

  componentDidMount() {
    window.addEventListener('resize', this.calculateTabWidth);
    this.calculateTabWidth();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.calculateTabWidth);
  }

  render() {
    var _this$props = this.props,
        {
      children,
      isInverse = false,
      activeTabIndex,
      onChangeTabIndex,
      activeBarStyles
    } = _this$props,
        otherTabsProps = _objectWithoutProperties(_this$props, _excluded);

    var {
      isScrollable
    } = this.state;
    return /*#__PURE__*/jsx(TabContext.Provider, {
      value: {
        onClick: this.handleClick,
        selectedIndex: activeTabIndex,
        styles: activeBarStyles
      },
      children: /*#__PURE__*/jsxs(Wrapper, _objectSpread2(_objectSpread2({}, otherTabsProps), {}, {
        ref: this.node,
        isInverse: isInverse,
        isScrollable: isScrollable,
        role: "tablist",
        children: [isScrollable && /*#__PURE__*/jsx(LeftIconWrapper, {
          onClick: this.handleMoveScrollbarRight,
          children: /*#__PURE__*/jsx(ChevronLeft, {
            height: "24px",
            width: "24px",
            color: getColour('interaction', 'main')
          })
        }), activeBarStyles && /*#__PURE__*/jsx(ActiveBar, {
          styles: activeBarStyles
        }), React.Children.map(children, this.renderTab), isScrollable && /*#__PURE__*/jsx(RightIconWrapper, {
          onClick: this.handleMoveScrollbarLeft,
          children: /*#__PURE__*/jsx(ChevronRight, {
            height: "24px",
            width: "24px",
            color: getColour('interaction', 'main')
          })
        })]
      }))
    });
  }

}

_defineProperty(Tabs, "Tab", Tab);

export { Tabs as default };
